import { NgClass } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ENVIRONMENT_CONFIG } from '@core/config-angular';

@Component({
  selector: 'wl-navigation-header',
  standalone: true,
  imports: [NgClass],
  templateUrl: './navigation-header.component.html',
  styleUrls: [
    './navigation-header.component.ed.scss',
    './navigation-header.component.essent.scss',
  ],
})
export class NavigationHeaderComponent {
  readonly #config = inject(ENVIRONMENT_CONFIG);

  readonly enableEssentRebranding =
    this.#config.styles?.enableEssentRebranding || false;
}
